<template>
  <div>
    <div v-if="show" class="fdd-text-tips">
      <span class="text-hide">{{ text | shortStr(maxlength) }}</span>
      <span class="fdd-text-word">{{ text }}</span>
    </div>
    <div v-else>
      {{ text }}
    </div>
  </div>
</template>
<script>
  export default {
    name: 'FddTextTips',
    filters: {
      shortStr(text, length) {
        let str = text + ''
        if (str.length > length) {
          return str.substring(0, length) + '...'
        } else {
          return str
        }
      }
    },
    props: {
      text: {
        default: '',
        type: String
      },
      maxlength: {
        default: 10,
        type: Number
      }
    },
    computed: {
      show() {
        return this.text && this.text.length > this.maxlength
      }
    }
  }
</script>
